import { render, staticRenderFns } from "./conditions-of-use.vue?vue&type=template&id=4a15ddc4&"
import script from "./conditions-of-use.vue?vue&type=script&lang=ts&"
export * from "./conditions-of-use.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports